export default "__VITE_ASSET__CcYTgPEL__"